export const MEDIA_MIN_TABLET = '@media (min-width: 768px)';
export const MEDIA_MIN_DESKTOP = '@media (min-width: 1080px)';
